<!--    通知-->
<template>
    <div class="notify-con">
        <div :class="{'blur':addFlag}">
            <vs-row vs-type="flex" vs-align="center">
                <vs-col vs-w="6" vs-sm="4">
                    <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.notifications')}}</span>
                </vs-col>
                <vs-col vs-w="6" vs-sm="8" vs-type="flex" vs-justify="flex-end">
                    <vs-button v-role="['admin']" size="small" color="rgb(37, 105, 193)" type="border" style="border-radius: 15px;" @click="addFlag = true">+ {{$t('message.addNotifications')}}</vs-button>
                    <vs-button v-role="['admin']" v-if="data[0]" size="small" type="filled" style="border-radius: 15px;margin-left: 5px;" @click="delFlag = !delFlag">{{$t('message.edit')}}</vs-button>
                    <vs-button v-role="['user']" size="small" color="rgb(37, 105, 193)" @click="$router.push('/contact')">{{$t('message.contactUs')}}</vs-button>
                </vs-col>

            </vs-row>

            <div v-if="isMobile()">
                <vs-row class="notify-card notify-card-mob" vs-type="flex" vs-align="center" v-for="item in data" :key="item.id">
                    <vs-col vs-w="1.5" class="check" vs-type="flex" vs-justify="center">
                        <transition name="fade">
                            <button class="checkBtn" :class="{'checkedBtn':item.state == 'unread'}" v-if="item.state == 'unread'" @click="onRead(item)"></button>
                        </transition>
                    </vs-col>
                    <vs-col vs-w="9">
                        <label for="">{{$t('message.date')}}</label>
                        <p style="font-weight: 600;font-size: 18px;">{{item.date | dateFormat}}</p>
                    </vs-col>
                    <vs-col vs-w="1.5">
                        <transition name="fade">
                            <feather-icon icon='XCircleIcon' class="featherBtn red cursor-pointer" @click="onDelete(item._id)" v-if="delFlag"></feather-icon>
                        </transition>
                    </vs-col>
                    <vs-col vs-w="1.5"></vs-col>
                    <vs-col vs-w="10.5">
                        <vs-row>
                            <vs-col>
                                <label for="">{{$t('message.subject')}}</label>
                                <p>{{item.subject.tran()}}</p>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col>
                                <label for="">{{$t('message.detail')}}</label>
                                <p>{{item.content.tran()}}</p>
                            </vs-col>
                        </vs-row>

                    </vs-col>
                </vs-row>
            </div>
            <div v-else>
                <vs-row class="notify-card" vs-type="flex" vs-align="center" v-for="item in data" :key="item.id" >
                    <vs-col vs-w="1" class="check">
                        <transition name="fade">
                            <button class="checkBtn" :class="{'checkedBtn':item.state == 'unread'}" v-if="item.state == 'unread'" @click="onRead(item)"></button>
                        </transition>
                    </vs-col>
                    <vs-col vs-w="3">
                        <label for="">{{$t('message.date')}}</label>
                        <p style="font-weight: 600;font-size: 18px;">{{item.date | dateFormat}}</p>
                    </vs-col>
                    <vs-col vs-w="7">
                        <vs-row>
                            <vs-col style="padding: 0">
                                <label for="">{{$t('message.subject')}}</label>
                                <p>{{item.subject.tran()}}</p>
                            </vs-col>
                        </vs-row>
                        <vs-row style="margin-top: 10px">
                            <vs-col style="padding: 0">
                                <label for="">{{$t('message.detail')}}</label>
                                <p>{{item.content.tran()}}</p>
                            </vs-col>
                        </vs-row>

                    </vs-col>
                    <vs-col vs-w="1">
                        <transition name="fade">
                            <feather-icon icon='XCircleIcon' svgClasses='h-7 w-7' class="red cursor-pointer" @click="onDelete(item._id)" v-if="delFlag"></feather-icon>
                        </transition>
                    </vs-col>
                </vs-row>
            </div>
        </div>

        <vs-popup :active.sync="addFlag" title=" ">
            <div class="card-title">
                {{$t('message.newNotifications')}}
            </div>
            <vs-row class="m-t-1">
                <vs-col vs-w="6">
                    <label>{{$t('message.date')}}</label>
                    <datepicker class="fixedPicker" v-model="nofitication.date" :format="format"
                                :highlighted="highlight"></datepicker>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="12">
                    <label>{{$t('message.subject')}}</label>
                    <vs-input v-model="nofitication.subject" style="width: 100%"></vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-1">
                <vs-col vs-w="12">
                    <label>{{$t('message.detail')}}</label>
                    <textarea v-model="nofitication.content" name="content"></textarea>
                </vs-col>
            </vs-row>
            <vs-row class="m-t-2">
                <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                    <vs-button size="small" color="rgb(37, 105, 193)" style="border-radius: 3px;padding: 5px 20px;" @click="onCreateNotification()">{{$t('message.add')}}</vs-button>
                </vs-col>
            </vs-row>
        </vs-popup>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {mapGetters} from 'vuex';
    export default {
        data() {
            return {
                format: 'dd / MM / yyyy',
                highlight: {
                    customPredictor(date) {
                        if ((date.getDate() - new Date().getDate() == 0) && (date.getMonth() - new Date().getMonth() == 0))
                            return true;
                    }
                },
                token:'',
                data:[],
                addFlag:false , //add notice,
                nofitication:{
                    subject:'',
                    content:'',
                    date:''
                },
                delFlag:false
            }
        },
        created() {
            this.token = this.$cookies.get('token');
            this.$vs.loading({
                type:'point'
            })
            this.$store.dispatch('getFlag',{token:this.$cookies.get('token')})
            let url = process.env.VUE_APP_API_BASEURL + '/api/announcement?access_token=' + this.$cookies.get('token');
            fetch(url).then((response) => {
                return response.json();
            }).then((result) =>{
                this.data = result.responseDetail.data;
                if(result){
                    this.$vs.loading.close()
                }
            })
        },
        computed:{
            ...mapGetters(["currentUser"])
        },
        methods: {
            onReload(){
                this.$vs.loading({
                    type:'point'
                })
                let url = process.env.VUE_APP_API_BASEURL + '/api/announcement?access_token=' + this.token;
                fetch(url).then((response) => {
                    return response.json();
                }).then((result) =>{
                    this.data = result.responseDetail.data
                    if(result){
                        this.$vs.loading.close()
                    }
                })
            },
            onRead(item){
                let url = process.env.VUE_APP_API_BASEURL + '/api/me/announcement/flag?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id:item._id,
                        state:'read'
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode == 200){
                        item.state = 'read'
                        this.$store.dispatch('getFlag',{token:this.$cookies.get('token')})
                    }
                });
            },
            onCreateNotification(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/announcement?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        subject:this.nofitication.subject,
                        content:this.nofitication.content,
                        date:this.nofitication.date
                    })
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.nofitication = {
                            subject:'',
                            content:'',
                            date:''
                        }
                        this.addFlag = false;
                        this.onReload();
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
            onDelete(id){
                let url = process.env.VUE_APP_API_BASEURL + '/api/announcement/delete/'+ id +'?access_token=' + this.token;
                fetch(url, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    if(result.responseCode === 200){
                        this.$store.dispatch('getFlag',{token:this.$cookies.get('token')})
                        this.onReload()
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorDel'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                });
            },
        },
        components: {
            Datepicker
        },
    }
</script>
<style scoped>
    @import '../assets/css/alert.css';
    .notify-con label{
        font-size: 13px;
    }
    .notify-card{
        border: 1px solid whitesmoke;
        padding: 10px 0;
        margin-top: 15px;
    }
    .notify-card label{
        color: rgb(37, 105, 193);
        font-weight: 500;
        margin: 0;
    }
    .notify-card p{
        margin: 0;
        color: #aab4c4;
        font-size: 16px;
        font-weight: 500;
    }
    .checkBtn{
        border: 2px solid #cecece;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        background: white;
    }

    @media screen and (max-width: 500px){
        .checkBtn{
            width: 17px;
            height: 17px;
        }
    }
    .checkedBtn{
        border: 2px solid rgb(232, 193, 137);
        background: rgb(232, 193, 137);
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }
</style>
<style>
    .notify-card-mob .vs-col{
        padding-left: 5px;
        padding-right: 0;
    }
    .featherBtn svg{
        width: 19px;
        height: 19px;
    }
</style>
